import { FC } from 'react'
import { Loader } from 'semantic-ui-react'

interface ILoaderProps {
  loading: boolean
  children: JSX.Element
}

export const LoaderWrap: FC<ILoaderProps> = props =>
  props.loading ? (
    <div style={{ textAlign: 'center' }}>
      <Loader inline active />
    </div>
  ) : (
    props.children
  )
